// extracted by css-extract-rspack-plugin
export default {"snapshotsList":"snapshotsList-nI_4mL"};